// extracted by mini-css-extract-plugin
export default {"usersList":"UserList_usersList__WivEE","close":"UserList_close__o2rxi"};